import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUniparc = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 12 16",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M0 4.98V3.56C0 1.59 2.55 0 5.69 0c3.14 0 5.69 1.6 5.69 3.56v1.42c0 1.96-2.55 3.55-5.7 3.55C2.56 8.53 0 6.94 0 4.98z" }),
		/* @__PURE__ */ _jsx("path", { d: "M11.35 7.11c-.29 1.8-2.71 3.2-5.66 3.2S.3 8.91.03 7.11a2.28 2.28 0 00-.03.36v1.42c0 1.96 2.55 3.55 5.69 3.55 3.14 0 5.69-1.59 5.69-3.55V7.47a2.26 2.26 0 00-.03-.36z" }),
		/* @__PURE__ */ _jsx("path", { d: "M5.69 13.87c2.95 0 5.37-1.4 5.66-3.2.02.11.03.23.03.35v1.42c0 1.97-2.55 3.56-5.7 3.56C2.56 16 0 14.4 0 12.44v-1.42c0-.12.01-.24.03-.35.28 1.8 2.7 3.2 5.66 3.2z" })
	]
});
export default SvgUniparc;
